<client-item-tag>

  <div class="contents_block {isUnread(props.client.unreadNum)} margin-spacing-2_bottom" onclick={(e)=>goList(props.client.client_id)} style="cursor:pointer">
    <div class="user">
      <div class="user-icon">
        <img src="/assets/img/icon_account.svg" alt="">
      </div>
      <div class="user-name user-name_client">
        <a>{props.client.name}</a>
      </div>
    </div><!--/.user-->
    <div class="recent_message">
      <p class="text">{latest_name}</p>
      <div>{latest_message}</div><!-- 最新の会話 -->
      <p class="message_date align_r margin-spacing-2_top">{props.client.created_at}</p>
    </div>
  </div><!--/.contents_block-->

<script>
  import di from "dependency-injection";
  export default {
    latest_name: '',
    latest_message: '',
    latest_created_at: '',
    isUnread(unreadNum){
      if (unreadNum > 0) return 'chat_unread';
      return '';
    },
    goList(id) {
      di.router.push(`/chat/index/${id}`);
    },
    onBeforeUpdate(props, state) {
      if (props.client.data) {
        const latest = JSON.parse(props.client.data);
        this.latest_name = latest.name;
        this.latest_message = latest.message;
      }
    },
    onBeforeMount(props, state){
      if (props.client.data) {
        const latest = JSON.parse(props.client.data);
        this.latest_name = latest.name;
        this.latest_message = latest.message;
      }
    }
  }
</script>
</client-item-tag>
